import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger
} from '@/components/ui/dropdown-menu'
import { SidebarTrigger } from '@/components/ui/sidebar'
import { logger } from '@/lib/logger'
import { useDevicesStore } from '@/stores/devices-store'
import { Smartphone } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function AppHeader() {
    const { t } = useTranslation()
    const currentDevice = useDevicesStore((state) => state.currentDevice)
    const availableDevices = useDevicesStore((state) => state.availableDevices)
    const setSelectedDevice = useDevicesStore((state) => state.setSelectedDevice)

    logger.debug('Header rendered', {
        currentDevice: currentDevice?.name,
        deviceCount: availableDevices.length
    })

    return (
        <header className="flex h-16 shrink-0 items-center gap-2 border-b px-4 bg-white">
            <SidebarTrigger />

            <div className="flex flex-1 items-center justify-start">
                <div className="flex items-center gap-4">

                    {/* Device Selector */}
                    <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                            <Button variant="outline" size="sm" className="gap-2">
                                <Smartphone className="h-4 w-4" />
                                <span className="hidden sm:inline">{currentDevice?.customerName || currentDevice?.name || t('header.selectDevice')}</span>
                            </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent align="start" className="w-56">
                            <DropdownMenuLabel>{t('header.availableDevices')}</DropdownMenuLabel>
                            <DropdownMenuSeparator />
                            {availableDevices.length === 0 ? (
                                <DropdownMenuItem disabled>
                                    {t('header.noDevices')}
                                </DropdownMenuItem>
                            ) : (
                                availableDevices.map((device) => {
                                    const isMds = device.type === 'DEVICE_SELECTOR'
                                    return (
                                        <DropdownMenuItem
                                            key={device.id}
                                            onClick={() => setSelectedDevice(device, device.deviceId)}
                                            className={currentDevice?.id === device.id ? 'bg-accent' : ''}
                                        >
                                            <div className="flex flex-col flex-1">
                                                <div className="flex items-center gap-2">
                                                    <span className="font-medium">{device.customerName || device.name || t('header.unnamedDevice')}</span>
                                                    {isMds && (
                                                        <Badge variant="secondary" className="text-xs px-1.5 py-0 h-5 bg-brand-primary/10 text-brand-primary border-brand-primary/20">
                                                            MDS
                                                        </Badge>
                                                    )}
                                                </div>
                                                <span className="text-xs text-muted-foreground">ID: {device.deviceId}</span>
                                            </div>
                                        </DropdownMenuItem>
                                    )
                                })
                            )}
                        </DropdownMenuContent>
                    </DropdownMenu>

                    {/* MDS Badge */}
                    {currentDevice?.type === 'DEVICE_SELECTOR' && (
                        <span className="px-2 py-1 text-xs font-semibold bg-brand-primary text-white rounded">
                            MDS
                        </span>
                    )}
                </div>
            </div>
        </header>
    )
}